module.exports = __webpack_public_path__ + "img/empty-widget.a87595d0.svg";